import { WarningsReducerState } from './types';

export const getDefaultState = (): WarningsReducerState => ({
  isOpened: false,
  messages: []
});
